/**
 * Admin sidebar — product desks still in launch scope + platform tools.
 */

export const ADMIN_NAV_GROUPS = [
  {
    id: "command",
    label: "Command",
    items: [
      {
        id: "overview",
        label: "Overview",
        hint: "Mission control",
        description: "Platform snapshot — users, bets, payments, system health",
      },
    ],
  },
  {
    id: "desks",
    label: "Product desks",
    items: [
      {
        id: "p2p",
        label: "P2P",
        hint: "Peer bets",
        description: "Peer-to-peer bets — monitor, settle, void",
      },
      {
        id: "predictions",
        label: "Tips",
        hint: "AI · community",
        description: "AI and community tips — engagement and moderation",
      },
    ],
  },
  {
    id: "community",
    label: "Community",
    items: [
      {
        id: "leaderboard",
        label: "Leaderboard",
        hint: "Rankings · rewards",
        description: "Rankings, scores, and period rewards",
      },
      {
        id: "referrals",
        label: "Referrals",
        hint: "Codes · rewards",
        description: "Referral signups, pending rewards, and payout history",
      },
      {
        id: "chat-moderation",
        label: "Chat reports",
        hint: "BondChat · bans",
        description: "Review reported lounge and match-room messages",
        superAdminOnly: true,
      },
    ],
  },
  {
    id: "finance",
    label: "Finance",
    items: [
      {
        id: "transaction",
        label: "Transactions",
        hint: "Deposits · ledger",
        description: "Deposits, withdrawals, and ledger review",
      },
      {
        id: "treasury",
        label: "Treasury",
        hint: "Liquidity · escrow",
        description: "Provider balance, user wallets, and locked funds",
      },
    ],
  },
  {
    id: "people",
    label: "People & access",
    items: [
      {
        id: "users",
        label: "Users",
        hint: "Roles · bans",
        description: "Search, ban, roles, transactions",
        superAdminOnly: true,
      },
    ],
  },
  {
    id: "platform",
    label: "Platform",
    items: [
      {
        id: "leagues",
        label: "Leagues",
        hint: "API-Sports sync",
        description: "API-Sports leagues — enable, seasons, sync",
        superAdminOnly: true,
      },
      {
        id: "system",
        label: "System",
        hint: "Jobs · Redis",
        description: "Jobs, queues, Redis",
        superAdminOnly: true,
      },
    ],
  },
];

export function getAllNavItems(userRole) {
  const isSuper = userRole === "super_admin";
  return ADMIN_NAV_GROUPS.flatMap((g) =>
    g.items.filter((item) => !item.superAdminOnly || isSuper)
  );
}

export function getNavItem(id, userRole) {
  return getAllNavItems(userRole).find((item) => item.id === id) || null;
}

export function getNavGroups(userRole) {
  const isSuper = userRole === "super_admin";
  return ADMIN_NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => !item.superAdminOnly || isSuper),
  })).filter((group) => group.items.length > 0);
}

export function getDefaultSection() {
  return "overview";
}

export const BUILT_SECTIONS = new Set([
  "overview",
  "users",
  "leaderboard",
  "referrals",
  "chat-moderation",
  "p2p",
  "transaction",
  "treasury",
  "predictions",
  "leagues",
  "system",
]);

export function isBuiltSection(id) {
  return BUILT_SECTIONS.has(id);
}
